import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-pages',
  templateUrl: './manage-pages.component.html',
  styleUrls: ['./manage-pages.component.css']
})
export class ManagePagesComponent implements OnInit {

  title = 'Manage Pages';
  constructor() { }

  ngOnInit() {
  }

}
